import { Sparkles, Cpu, Zap, Leaf, Droplet, Droplets, ShieldCheck, BadgeCheck, FileCheck2, Flag, Wrench, Sun, Bot, Building2 } from "lucide-react";

const MAP = {
  sparkles: Sparkles,
  cpu: Cpu,
  zap: Zap,
  leaf: Leaf,
  droplet: Droplet,
  droplets: Droplets,
  shield: ShieldCheck,
  badge: BadgeCheck,
  file: FileCheck2,
  flag: Flag,
  wrench: Wrench,
  sun: Sun,
  bot: Bot,
  building: Building2,
};

export const getIcon = (name) => MAP[(name || "").toLowerCase()] || BadgeCheck;

export const ICON_OPTIONS = Object.keys(MAP);

// Extract a YouTube video id from a watch url, embed url, or raw id.
export const ytId = (urlOrId) => {
  if (!urlOrId) return "";
  const s = String(urlOrId).trim();
  const m = s.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
  if (m) return m[1];
  return s; // assume raw id
};
